var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfSellCarIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28032",
    "data-name": "\\uC0AC\\uAC01\\uD615 28032",
    width: 40,
    height: 40,
    transform: "translate(562.836 71.745)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21743",
    "data-name": "\\uADF8\\uB8F9 21743",
    transform: "translate(-682 -1499.588)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1225",
    "data-name": "\\uD0C0\\uC6D0 1225",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(708 1522)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21560",
    "data-name": "\\uADF8\\uB8F9 21560",
    transform: "translate(115.164 1422.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21559",
    "data-name": "\\uADF8\\uB8F9 21559",
    transform: "translate(4 5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28031",
    "data-name": "\\uC0AC\\uAC01\\uD615 28031",
    width: 40,
    height: 40,
    transform: "translate(562.836 71.745)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21742",
    "data-name": "\\uADF8\\uB8F9 21742",
    transform: "translate(-305 -2138)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_45",
    "data-name": "\\uC120 45",
    y2: 27.128,
    transform: "translate(993.496 3644.023)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_46",
    "data-name": "\\uC120 46",
    x1: 26.39,
    transform: "translate(993.496 3671.152)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10183",
    "data-name": "\\uD328\\uC2A4 10183",
    d: "M578.049,105.326s.93-6.847,5.619-4.76c4.053,1.8,2.491-6.391,6.2-7.891,3.927-1.587,3.762,2.7,9.237-3.195",
    transform: "translate(420 3561)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10184",
    "data-name": "\\uD328\\uC2A4 10184",
    d: "M595.314,87.871h5.193v6.217",
    transform: "translate(420 3561)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSellCarIcon3);
export default __webpack_public_path__ + "static/media/SelfSellCarIcon3.e3dbdadf1551c6e0006fca372603f30b.svg";
export { ForwardRef as ReactComponent };